import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter
} from '@reduxjs/toolkit'
import { AxiosResponse } from "axios";
import { API_PATH } from '../../constants';
import { NewHostSelection } from '../../Classes1';
import { http } from '../../utils/config';

const hotwashAdapter = createEntityAdapter<any>()

const initialState = hotwashAdapter.getInitialState()

const hotwashSlice = createSlice({
    name: 'hotwash',
    initialState,
    reducers: {
      hotwashToggled(state, action) {
        //const scenarioId = action.payload
      },
    }
})

export default hotwashSlice.reducer;

export const updateHotwashSelection = createAsyncThunk(
  'hotwash/updateHotwashSelection',
  async ( newHostSelection: NewHostSelection, { rejectWithValue }) => {
    try {
      
      const response = await http.post(API_PATH + '/hotwash/' + newHostSelection.hotwashId + '/select', { selection: newHostSelection.hostSelection });
      return response.status
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getHotwashStatus = createAsyncThunk(
    'hotwash/getHotwashStatus',
    async (hotwashId: string | null, { rejectWithValue }) => {
      try {
        
        const response: AxiosResponse<any, any> = await http.get(API_PATH + '/hotwash/' + hotwashId + '/status');
        return response.data
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
  )

  export const getHotwashesByScenarioId = createAsyncThunk(
    'hotwash/getHotwashesByScenarioId',
    async (scenarioId: string | null, { rejectWithValue }) => {
      try {
        
        const response: AxiosResponse<any, any> = await http.get(API_PATH + '/hotwash/' + scenarioId);
        return response.data
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
  )

  export const getAllHotwashes = createAsyncThunk(
    'hotwash/getAllHotwashes',
    async () => {
      try {
        const response = await http.get(API_PATH + '/hotwash');
        return response.data
      } catch (error: any) {
        return error;
      }
    }
  )